import { library } from '@fortawesome/fontawesome-svg-core';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import ProductLink from '@jetshop/ui/ProductLink';
import ProductImage from '@jetshop/ui/ProductList/ProductImage';
import theme from '@jetshop/ui/utils/theme';
import { css } from 'emotion';
import React, { Component } from 'react';
import styled from 'react-emotion';
import ImageMissing from '../../img/image-missing.jpg';
import { Price } from '../Price';
import PricePromotion from '../Price/PricePromotion';
import { VatContext } from '../Price/VatContext';
import AddFavoriteButton from '../ProductList/AddFavoriteButton';
import { QuickBuyButton } from '../ui/QuickBuyButton';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

library.add(faStar);

export const ProductWrapper = styled('div')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  align-items: flex-start;
  background: white;
  position: relative;
  img {
    max-width: 100%;
    height: auto;
  }
`;

export const ProductBlockLink = styled(ProductLink)`
  text-decoration: none;
  color: inherit;
  display: block;
  margin-right: 15px;
  margin-left: 15px;
  margin-bottom: 36px;
  background-color: white;
  width: 200px;
  flex: 0 0 auto;
  position: relative;

  .price-promotion {
    top: -5px;
    right: -10px;
  }
`;
export const ProductDetails = styled('div')`
  background-color: white;
  padding: 15px 5px;
  max-width: 100%;
  max-height: 100%;
  text-align: left;
  flex: 1 1 auto;
  max-width: 480px;
  position: relative;
  strong {
    font-weight: 700;
  }
`;
export const Name = styled('p')`
  font-size: 18px;
  font-weight: 900;
  text-transform: uppercase;
  margin-bottom: 0;
  min-height: 32px;
`;
export const ArticleNumber = styled('p')`
  font-size: 14px;
  color: #9a9a9a;
  margin-bottom: 10px;
  font-weight: 900;
`;
export const StyledProductImage = styled(ProductImage)`
  img + div {
  }
`;

export const StyledPrice = styled(Price)`
  font-weight: bold;
  letter-spacing: -0.5px;
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  ${Price.Old} {
    font-weight: 400;
  }
  + div {
    color: #636363;
    font-size: 13px;
  }
  ${Price.New} {
    color: ${theme('colors.red')};
  }
`;

const BuyButtonArea = styled('section')`
  flex: 0 0 auto;
  text-align: center;
`;

const InfoButton = styled(FontAwesomeIcon)`
  font-size: 1.5rem;
  cursor: pointer;
`;

const ToolTip = styled('div')`
  position: absolute;
  background: #fff;
  border: 1px solid #ddd;
  padding: 15px;
  z-index: 999;
  right: 0;
  top: 0;
  text-align: left;
  font-family: 'Open Sans', sans-serif;
  line-height: 1.3;
  font-size: 14px;
  max-height: 500px;
  overflow-y: auto;
  .hide {
    display: none;
  }
`;

const ModelTable = styled('table')`
  width: 100%;
  th {
    font-weight: 900;
  }
  th,
  td {
    padding: 5px;
  }
`;

const ToggleModelList = styled('div')`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  padding-top: 5px;
  text-transform: uppercase;
  svg {
    margin-right: 10px;
  }
`;

class ModelList extends Component {
  render() {
    const { items } = this.props;
    return (
      <ModelTable>
        <tbody>
          {items.map((item) => (
            <tr key={item.key}>
              <th>{item.title}</th>
              <td>{item.value}</td>
            </tr>
          ))}
        </tbody>
      </ModelTable>
    );
  }
}

class ListProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModels: false,
      showButtons: false,
    };
  }
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick, false);
  }
  handleClick = (e) => {
    if (document.getElementById('models-' + this.props.product.id)) {
      if (
        !document
          .getElementById('models-' + this.props.product.id)
          .contains(e.target)
      ) {
        this.setState({ showModels: false });
      }
    }
  };
  showModels() {
    this.setState({ showModels: !this.state.showModels });
  }
  modelsExists(customFields) {
    for (var i = 0; i < customFields.length; i++) {
      if (
        customFields[i].title?.toLowerCase() === 'passar modeller' &&
        customFields[i].items
      ) {
        return true;
      }
    }
  }
  render() {
    const { product, categoryPath, loading, className = '' } = this.props;
    const { showModels } = this.state;
    return (
      <ProductWrapper data-testid="product" className={className}>
        <ProductBlockLink
          product={product}
          categoryPath={categoryPath}
          className={
            loading &&
            css`
              opacity: 0.5;
            `
          }
        >
          {product.images[0] ? (
            <StyledProductImage
              className="product-image"
              aspect="1:1"
              src={product.images[0].url}
              alt={product.images[0].alt}
              title={product.images[0].title}
              badges={product.badges}
            />
          ) : (
            <img src={ImageMissing} alt={product.name} />
          )}
          {product.price &&
            product.previousPrice.incVat !== product.price.incVat && (
              <PricePromotion
                className="price-promotion"
                previousPrice={product.previousPrice.incVat}
                price={product.price.incVat}
              />
            )}
        </ProductBlockLink>
        <AddFavoriteButton product={product} />

        <ProductDetails>
          <Name>{product.name}</Name>
          <ArticleNumber>{product.articleNumber}</ArticleNumber>

          {product.customFields && (
            <React.Fragment>
              {this.modelsExists(product.customFields) && (
                <ToggleModelList onClick={() => this.showModels()}>
                  <InfoButton icon={['fal', 'bars']} />
                  <span>Passar modeller</span>
                </ToggleModelList>
              )}
            </React.Fragment>
          )}

          {product.customFields && showModels && (
            <div>
              {product.customFields.map((field) => (
                <React.Fragment>
                  {field.title?.toLowerCase() === 'passar modeller' && (
                    <ToolTip id={'models-' + product.id}>
                      <ModelList items={field.items} />
                    </ToolTip>
                  )}
                </React.Fragment>
              ))}
            </div>
          )}

          <summary
            dangerouslySetInnerHTML={{
              __html: product.description,
            }}
          />
        </ProductDetails>
        <BuyButtonArea>
          <VatContext>
            {({ incVat }) => (
              <StyledPrice
                includeVat={incVat}
                price={product.price}
                previousPrice={product.previousPrice}
              />
            )}
          </VatContext>

          <QuickBuyButton product={product} productListView />
        </BuyButtonArea>
      </ProductWrapper>
    );
  }
}
export default ListProduct;
